import config from '../config';

export const getImageUrl = (path: string): string => {
  if (path.startsWith('uploads') || path.startsWith('assets')) {
    return `${config.imgixDomain}${path}`;
  }

  return path;
};
